import { SportsApiClient } from '@collector/sportsapi-client'
import type { OccursAction } from '@collector/sportsapi-types'

import {
  BaseIncident,
  type QueueIncidentError,
  type QueueIncidentStatus,
} from './BaseIncident.js'

export class ChangeOrderIncident extends BaseIncident {
  readonly type = 'ChangeOrder'
  readonly isConfirmable = false

  readonly id: number
  readonly action: OccursAction

  constructor(
    eventId: number,
    incidentId: number,
    action: OccursAction,
    status?: QueueIncidentStatus,
    time?: number,
    error?: QueueIncidentError,
  ) {
    super(eventId, status, time, error)

    this.id = incidentId
    this.action = action
  }

  override async process(sportsApiClient: SportsApiClient): Promise<string> {
    await sportsApiClient.Events.Incidents.Occurs.post(
      this.eventId,
      this.id,
      this.action,
    )

    return ''
  }
}
